import {
  axiosInstance,
  GET_FOLDER_URL,
  GET_QUESTION_BANKS_URL,
  GET_ONE_QUETION_BANK_URL,
  SUBMIT_QUESTION_BANK_URL,
  GET_QUESTION_BANK_RESULT_URL,
  GET_INSTITUTION_FOLDER_URL,
  GET_INSTITUTION_QUESTION_BANKS_URL,
  GET_ONE_INSTITUTION_QUESTION_BANK_URL,
  SUBMIT_INSTITUTION_QUESTION_BANK_URL,
  GET_INSTITUTION_QUESTION_BANK_RESULT_URL,
} from "../apiurls/apiurls";

export const getQuestionBankFolders = async ({ title, key }) => {
  try {
    const response = await axiosInstance.get(
      `${GET_FOLDER_URL}?title=${encodeURIComponent(
        title
      )}&key=${encodeURIComponent(key || "")}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching question bank folders:", error);
    throw error;
  }
};

export const getQuestionBanksByFolder = async ({ folderId, page, limit }) => {
  try {
    const params = {
      questionbank_folders: folderId || "",
    };
    if (page !== undefined) params.page = page;
    if (limit !== undefined) params.limit = limit;
    const response = await axiosInstance.get(GET_QUESTION_BANKS_URL, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching question banks by folder:", error);
    throw error;
  }
};

export const getOneQuestionBank = async ({ id }) => {
  try {
    const response = await axiosInstance.get(
      `${GET_ONE_QUETION_BANK_URL}?id=${encodeURIComponent(id || "")}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching one question bank:", error);
    throw error;
  }
};

export const submitQuestionBankResult = async (params, payload) => {
  try {
    const response = await axiosInstance.post(SUBMIT_QUESTION_BANK_URL, payload, { params });
    return response.data;
  } catch (error) {
    console.error("Error submitting question bank result:", error);
    throw error;
  }
};

export const getQuestionBankResult = async (params) => {
  try {
    const response = await axiosInstance.get(GET_QUESTION_BANK_RESULT_URL, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching question bank result:", error);
    throw error;
  }
};

export const getQuestionBankInstitutionFolders = async ({ title, key }) => {
  try {
    const response = await axiosInstance.get(
      `${GET_INSTITUTION_FOLDER_URL}?title=${encodeURIComponent(
        title
      )}&key=${encodeURIComponent(key || "")}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching question bank institution folders:", error);
    throw error;
  }
};

export const getQuestionBanksInstitutionByFolder = async ({ folderId, page, limit }) => {
  try {
    const params = {
      questionbank_folders: folderId || "",
    };
    if (page !== undefined) params.page = page;
    if (limit !== undefined) params.limit = limit;
    const response = await axiosInstance.get(
      GET_INSTITUTION_QUESTION_BANKS_URL,
      { params }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching question banks institution by folder:", error);
    throw error;
  }
};

export const getOneQuestionBankInstitution = async ({ id }) => {
  try {
    const response = await axiosInstance.get(
      `${GET_ONE_INSTITUTION_QUESTION_BANK_URL}?id=${encodeURIComponent(id || "")}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching one question bank institution:", error);
    throw error;
  }
};

export const submitQuestionBankInstitutionResult = async (params, payload) => {
  try {
    const response = await axiosInstance.post(SUBMIT_INSTITUTION_QUESTION_BANK_URL, payload, { params });
    return response.data;
  } catch (error) {
    console.error("Error submitting question bank institution result:", error);
    throw error;
  }
};

export const getQuestionBankInstitutionResult = async (params) => {
  try {
    const response = await axiosInstance.get(GET_INSTITUTION_QUESTION_BANK_RESULT_URL, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching question bank institution result:", error);
    throw error;
  }
};
